<mat-expansion-panel (opened)="onOpened()" (closed)="opened = false" #panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ title | translate }}
    </mat-panel-title>
    @if (searchString?.length && numSelected === 0) {
      <div class="results">{{ filteredMediaFiles.length }} {{ "generic.results" | translate }}</div>
    }
    @if (numSelected > 0 && opened && !actionLoading) {
      <div class="actions">
        <i
          class="material-icons"
          [style.color]="'var(--colorButtonGray)'"
          [matTooltip]="'Move'"
          [matMenuTriggerFor]="moveMenu"
          (click)="openMoveOptions($event)">
          drive_file_move
        </i>
        <mat-menu #moveMenu="matMenu" class="move-menu">
          @for (category of otherCategories; track category) {
            <button mat-menu-item style="text-transform: capitalize" [matMenuTriggerFor]="collectionMenu" (mouseenter)="moveCategory = category">
              {{ category }}
            </button>
          }
        </mat-menu>
        <mat-menu #collectionMenu="matMenu" class="move-menu">
          @for (collection of otherCollections[moveCategory]; track collection) {
            <button mat-menu-item (click)="moveMediaFilesBatch($event, moveCategory, collection)">
              {{ collection.name }}
            </button>
          }
          <button mat-menu-item (click)="moveMediaFilesBatch($event, moveCategory, null)">default</button>
        </mat-menu>
        <mat-menu #categoryMenu="matMenu" class="move-menu">
          @for (category of otherCategories; track category) {
            <button mat-menu-item style="text-transform: capitalize" (click)="moveMediaFilesBatch($event, category)">
              {{ category }}
            </button>
          }
        </mat-menu>
        <i class="material-symbols-outlined cl-red" [matTooltip]="'generic.delete' | translate" (click)="deleteMediaBatch($event)">delete</i>
      </div>
    }
    @if (actionLoading) {
      <div class="actions">
        <mat-spinner class="spinner" [diameter]="18"></mat-spinner>
      </div>
    }
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div class="images-container">
      @if (!loading) {
        <div class="create-collection">
          <button
            mat-stroked-button
            class="add-collection"
            [matTooltip]="'campaign.widget.sidebar.media.create-collection' | translate"
            (click)="onAddCollectionClick()">
            <i class="material-symbols-outlined">create_new_folder</i>
            <span>{{ "campaign.widget.sidebar.media.create-collection" | translate }}</span>
          </button>
          @if (enteringCollectionName) {
            <div class="collection">
              <input
                #nameInput
                type="text"
                matInput
                [placeholder]="'campaign.widget.sidebar.media.collection-input' | translate"
                (keydown.enter)="createCollection()"
                [(ngModel)]="collectionName" />
              <i (click)="createCollection()" class="material-icons">check</i>
            </div>
          }
        </div>
        <div class="collections">
          @for (triggerbeeCollection of filteredTriggerbeeCollections; track triggerbeeCollection) {
            <div
              class="collection"
              (click)="onCollectionSelected(triggerbeeCollection.name)"
              [ngClass]="{ active: collectionView === triggerbeeCollection.name }">
              @if (this.darkMode) {
                <img src="assets/img/triggerbee_bullet_negative.png" class="triggerbee-logo" alt="triggerbee" />
              } @else {
                <img src="assets/img/bullet-black-triggerbee.png" class="triggerbee-logo" alt="triggerbee" />
              }
              <div class="name">{{ triggerbeeCollection.name.replace("Triggerbee ", "") }}</div>
              <i class="material-icons">folder</i>
            </div>
          }
        </div>
        <div class="collections">
          @if (collections.length > 0) {
            <div class="collection" (click)="onCollectionSelected('all')" [ngClass]="{ active: collectionView === 'all' }">
              @if (searchString && searchString.length > 0) {
                <div class="name">{{ "generic.results" | translate }}</div>
              } @else {
                <div class="name">{{ "generic.all" | translate }}</div>
              }
              <i class="material-icons">folder</i>
            </div>
          }
          @for (collection of filteredUserCollections; track collection) {
            <div class="collection" (click)="onCollectionSelected(collection.name)" [ngClass]="{ active: collectionView === collection.name }">
              <div class="name">{{ sanitizedCollectionName(collection.name) }}</div>
              <i class="material-icons">folder</i>
            </div>
          }
        </div>
        <div
          #child
          class="previous-list"
          cdkDropList
          cdkDropListSortingDisabled
          (cdkDropListDropped)="drop($event)"
          [cdkDropListData]="[]"
          [cdkDropListConnectedTo]="connectedParent">
          @if (!!filteredMediaFiles && filteredMediaFiles.length > 0) {
            @if (category === MediaCategory.Videos) {
              @for (mediaFile of filteredMediaFiles; track mediaFile) {
                <div
                  (click)="selectMediaFile(mediaFile)"
                  cdkDrag
                  [cdkDragDisabled]="true"
                  class="video-list-item"
                  [matTooltip]="mediaFile.filename"
                  [ngClass]="{ selected: selectedMediaFiles[mediaFile.filename] }">
                  <span class="video-filename">{{ mediaFile.filename }}</span>
                  @if (!mediaFile.triggerbeeImage) {
                    <div class="select" [ngClass]="{ selected: selectedMediaFiles[mediaFile.filename] }">
                      <i class="material-icons" (click)="toggleSelectedMediaFile($event, mediaFile)">check_circle</i>
                    </div>
                  }
                </div>
              }
            } @else {
              @for (mediaFile of filteredMediaFiles; track mediaFile) {
                <div
                  (click)="selectMediaFile(mediaFile)"
                  cdkDrag
                  [cdkDragData]="createImageComponentDescription(mediaFile)"
                  [cdkDragDisabled]="selectingMediaFile"
                  class="prev-loaded-image checkerboard"
                  [matTooltip]="mediaFile.filename"
                  [ngClass]="{ selected: selectedMediaFiles[mediaFile.filename] }">
                  <img
                    loading="lazy"
                    class="symbol"
                    (load)="mediaFile.loading = false"
                    [src]="mediaFile.url"
                    alt="img"
                    onError="this.src='/assets/img/campaign/preview_no_image.png'" />
                  @if (!mediaFile.triggerbeeImage) {
                    <div class="select" [ngClass]="{ selected: selectedMediaFiles[mediaFile.filename] }">
                      <i class="material-icons" (click)="toggleSelectedMediaFile($event, mediaFile)">check_circle</i>
                    </div>
                  }
                </div>
              }
            }
          }
          @if (collections.length === 0 && !!filteredMediaFiles && filteredMediaFiles.length === 0) {
            @if (category === MediaCategory.Photos) {
              <div class="no-images">{{ "campaign.widget.component.image.no-images" | translate }}</div>
            }
            @if (category === MediaCategory.Graphics) {
              <div class="no-images">{{ "campaign.widget.component.graphic.no-graphics" | translate }}</div>
            }
            @if (category === MediaCategory.Videos) {
              <div class="no-images">{{ "campaign.widget.component.video.no-videos" | translate }}</div>
            }
          }
          @if (!mediaFiles) {
            <mat-spinner></mat-spinner>
          }
        </div>
      } @else if (loading && opened) {
        <ng-container>
          <mat-spinner class="loading-spinner"></mat-spinner>
        </ng-container>
      }
    </div>
  </ng-template>
</mat-expansion-panel>
